export default __webpack_public_path__ + "static/media/profilephoto2.ec265450.jpg";